<template>
    <div class="flatPhotos">
        <div class="flat-carousel mb-4">
            <el-carousel :autoplay="false" arrow="always" height="400px" v-if="masObjImages != ''">
                <el-carousel-item v-for="obj_img in masObjImages" :key="obj_img.filename">
                    <img v-if="obj_img !=''" :src="obj_img.filename" alt="">
                </el-carousel-item>
            </el-carousel>
            <div>
                <img v-if="masObjImages == ''" src="/img/flatsDefault.svg" style="height: 100%;" alt=""> 
            </div>

        </div>
        
        <div class="objectAddress mt-5">
            <div class="metro">
                <div class="row flex-nowrap ml-0 mr-2 align-items-top" v-if="typeof objData!='undefined' && objData.metroName!=null  && objData.metroName!=''">
                    <i class="tim-ic ic-metro text-primary mr-1"></i>
                    <p>метро {{objData.metroName}}, </p>									
                </div> 								
                <div class="row ml-0 mr-2 align-items-center" v-if="typeof objData[0]!='undefined' && objData.fromSubway!=null  && objData.fromSubway!='' && objData.fromSubway !='0.00'">
                    <p>{{objData.fromSubway}} км</p>									
                </div> 								
            </div>
            <div class="" v-if="typeof objData!='undefined' "><p>{{objData.region}}, {{objData.address}}</p></div>
        </div>
        <div class="map mt-2">
            
            <div>
                <yandex-map
                    :settings="yamap_settings"
                    :coords="yamap_coords"
                    :zoom="yamap_zoom"
                    :scroll-zoom="false"
                    :controls="yamap_controls"
                    >
                
                    <ymap-marker
                            :coords="yamap_markers.coords"
                            :marker-id="yamap_markers.id"
                            marker-type="placemark"
                    />

                </yandex-map>
            </div>
        </div>

    </div>
</template>

<script>
    import { yandexMap, ymapMarker } from 'vue-yandex-maps';
    import { Carousel, CarouselItem } from "element-ui";	
    import mapSettings from 'src/conf/yandexmap.js';

    export default {
        components:{
            [Carousel.name]: Carousel,
    		[CarouselItem.name]: CarouselItem,

            yandexMap, ymapMarker,
        },
        data(){
            return {
                yamap_settings: {...mapSettings},
                yamap_coords: [59.93984485554249, 30.314527237792984],
                yamap_zoom: 17,
                yamap_controls:['zoomControl','typeSelector'],
                yamap_markers:{
                    coords: [59.93984485554249, 30.314527237792984],
                    id: '1',
                },
            }
        },
        props: {
            objData: {
                type: Object,
                default(){ return {}},
            },
        },
        watch: {
            objData: {
                deep: true,
                handler(val){
                    this.updateCoord();    
                }
            },
        },
        computed: {
            masObjImages: function(){
                let masImgs = [];
                if(typeof this.objData != 'undefined' && this.objData.image != '') {
                    const arrImages = JSON.parse(this.objData.image);
                    
                    for (let i = 0; i < arrImages.length; i++){
                        for (let value of Object.values(arrImages[i])) {
                            masImgs.push({filename: value.replace(/\\/g,'')});
                            // console.log(value);
                        }
                    }
                } 			
                return masImgs;
            },
        },
        methods:{
            updateCoord(){
                if(typeof this.objData !='undefined'){
                    /*
                    this.yamap_coords = [this.objData[0].houseLat,this.objData[0].houseLng];
                    this.yamap_markers.coords = [this.objData[0].houseLat,this.objData[0].houseLng];
                    */
                    this.yamap_coords = [this.objData.latitude,this.objData.longitude];
                    this.yamap_markers.coords = [this.objData.latitude,this.objData.longitude];
                }
            }
        },
        mounted(){
            this.updateCoord();
        }

    }
</script>

<style lang="scss" scoped>
    .flatPhotos {
        height: auto;
        flex-shrink: 0;
        img {
            height: 100%;
            border: 1px solid transparent;
            margin: 0 auto;
            display: block;
            object-fit: contain;
        }
    }

/*===carousel===============================*/

.flatPhotos >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.flatPhotos >>>  button:focus {outline: none!important;}
.flatPhotos >>> .el-carousel__arrow {background-color: rgb(62, 80, 101, 0.32);}
.flatPhotos >>> .el-carousel__arrow--right {right: 0;}
.flatPhotos >>> .el-carousel__arrow--left {left: 0;}
.objectProgress .el-carousel__item:nth-child(2n) {
  background: url("/img/73b0903ac774c473d1cd176b2fbe999f.jpeg") no-repeat center;
  background-size: contain;
} /*план поэтажный*/ 
.objectProgress .el-carousel__item:nth-child(2n + 1) {
  background: url("/img/9bht27nx4iuqcw3n0s4wyns4.png") no-repeat center;
  background-size: contain;
} /*план кв*/ 

</style>